import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useAdminLeadsVoPacks, useCancelPack, useConfirmPackPayment } from '../../../hooks/useLeadsVoQueries';

const statusConfig: Record<string, { label: string; color: string; bg: string }> = {
  pending_payment: { label: 'Paiement en attente', color: '#946200', bg: '#FFF4E0' },
  paid: { label: 'Payé', color: '#1B5E20', bg: '#E8F5E9' },
  active: { label: 'Actif', color: '#1B5E20', bg: '#E8F5E9' },
  closed: { label: 'Terminé', color: '#555', bg: '#EEE' },
  cancelled: { label: 'Annulé', color: '#B71C1C', bg: '#FDECEA' },
};

const methodLabel: Record<string, string> = {
  qonto_transfer: 'Virement',
  stripe_card: 'Carte',
  offered: 'Offert',
};

const AdminPacks = () => {
  const { data: packs, isLoading } = useAdminLeadsVoPacks();
  const { mutate: confirmPayment, isPending: isConfirming } = useConfirmPackPayment();
  const { mutate: cancelPack, isPending: isCancelling } = useCancelPack();

  if (isLoading) return <CircularProgress sx={{ color: '#FDBB5F' }} />;

  return (
    <Box sx={{ p: 3, maxWidth: 1300, mx: 'auto' }}>
      <Typography sx={{ fontWeight: 900, fontSize: 26, color: '#262626', mb: 3 }}>Packs Leads VO</Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            {['ID', 'Agence', 'Taille', 'Statut', 'Paiement', 'Montant TTC', 'Facture', 'Payé le', 'Actions'].map((h) => (
              <TableCell key={h} sx={{ fontWeight: 700, backgroundColor: '#262626', color: 'white' }}>
                {h}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(packs ?? []).map((pack: any) => {
            const cfg = statusConfig[pack.status] || statusConfig.pending_payment;
            const isPending = pack.status === 'pending_payment';
            return (
              <TableRow key={pack.id} hover>
                <TableCell>{pack.id}</TableCell>
                <TableCell>{pack.organization_name ?? `Organisation #${pack.organization_id}`}</TableCell>
                <TableCell>{pack.size} RDV</TableCell>
                <TableCell>
                  <Chip label={cfg.label} size="small" sx={{ color: cfg.color, backgroundColor: cfg.bg, fontWeight: 600 }} />
                </TableCell>
                <TableCell>
                  {methodLabel[pack.payment_method] || '—'}
                  {pack.payment_method === 'offered' && pack.gift_reason && (
                    <Typography sx={{ fontSize: 11, color: '#757575' }}>{pack.gift_reason}</Typography>
                  )}
                </TableCell>
                <TableCell>{pack.amount_ttc ? `${pack.amount_ttc}€` : '—'}</TableCell>
                <TableCell>{pack.qonto_invoice_number || '—'}</TableCell>
                <TableCell>{pack.paid_at ? new Date(pack.paid_at).toLocaleDateString('fr-FR') : '—'}</TableCell>
                <TableCell>
                  {isPending && (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button
                        size="small"
                        variant="contained"
                        disabled={isConfirming}
                        onClick={() => confirmPayment(pack.id)}
                        sx={{ backgroundColor: '#1B5E20', '&:hover': { backgroundColor: '#164a1a' }, fontSize: 12 }}
                      >
                        Valider paiement
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        disabled={isCancelling}
                        onClick={() => cancelPack(pack.id)}
                        sx={{ fontSize: 12 }}
                      >
                        Annuler
                      </Button>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {(!packs || packs.length === 0) && (
        <Typography sx={{ color: '#666', mt: 3, textAlign: 'center' }}>Aucun pack pour le moment.</Typography>
      )}
    </Box>
  );
};

export default AdminPacks;
